<template>
  <v-container fluid class="page-wrap">
     <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
            <v-card-title class="page-title-row">
                <div>
                    <div class="text-overline accent--text font-weight-bold">ATTENDANCE</div>
                    <div class="text-h6 font-weight-bold primary--text">Dashboard</div>
                    <div class="text-body-2 grey--text">Manage student and teacher attendance</div>
                </div>
            </v-card-title>
            <v-card-text>
                <common-dash-info/>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <!-- Student Attendance Section -->
      <v-col cols="12" md="6">
        <v-card elevation="3" class="rounded-xl pa-2 pa-md-3 fill-height">
          <v-card-title class="text-subtitle-1 font-weight-bold primary--text">
            <v-avatar size="40" class="action-tile-icon mr-3" rounded>
                <v-icon color="white">mdi-school</v-icon>
            </v-avatar>
            Student Attendance
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'MarkAttendance' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="success">mdi-pencil-outline</v-icon>
                    <span class="font-weight-medium">Record Attendance</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'AttendanceSummary' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="info">mdi-chart-bar</v-icon>
                    <span class="font-weight-medium">View Summary</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Teacher Attendance Section -->
      <v-col cols="12" md="6">
        <v-card elevation="3" class="rounded-xl pa-2 pa-md-3 fill-height">
          <v-card-title class="text-subtitle-1 font-weight-bold primary--text">
            <v-avatar size="40" class="action-tile-icon mr-3" rounded>
                <v-icon color="white">mdi-account-tie</v-icon>
            </v-avatar>
            Teacher Attendance
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'TeacherClock' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="primary">mdi-map-marker-radius-outline</v-icon>
                    <span class="font-weight-medium">Clock In/Out</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'TeacherClockSummary' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="deep-purple">mdi-calendar-check</v-icon>
                    <span class="font-weight-medium">View Clock Summary</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'ManageStaff' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="teal">mdi-account-tie-outline</v-icon>
                    <span class="font-weight-medium">Manage Staff</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card outlined class="rounded-lg action-tile pa-4" @click="$router.push({ name: 'GeoFence' })">
                  <div class="d-flex align-center">
                    <v-icon class="mr-3" color="warning">mdi-clock-outline</v-icon>
                    <span class="font-weight-medium">Configure Clock-in/out</span>
                    <v-spacer></v-spacer>
                    <v-icon color="grey">mdi-chevron-right</v-icon>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CommonDashInfo from '../../components/CommonDashInfo.vue'
import HeaderVue from '../../components/Header.vue'
export default {
  components: { CommonDashInfo, HeaderVue },
  name: 'AttendanceDashboard'
}
</script>

<style scoped>
.action-tile-icon {
  background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.action-tile {
  border: 1px solid #ECEFF7;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.action-tile:hover {
  box-shadow: 0 4px 24px rgba(30, 60, 114, 0.12) !important;
  transform: translateY(-2px);
}
</style>
